import styled, { css } from 'styled-components';

import { Media } from 'assets/Mixins.style';

export const Wrapper = styled.div`
  display: block;
  width: 100%;
`;

export const Title = styled.h3`
  display: block;
  max-width: 100%;
  width: 100%;
  margin: ${props => props.theme.margin.default};
  padding: ${props => props.theme.padding.default};
  transition: 0.2s all;
  border-radius: ${props => props.theme.borderRadius.default};
  color: ${props => props.titleColor || props.theme.color};
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};
  cursor: default;

  ${props =>
    props.theme.isBackground &&
    css`
      background: ${props => props.titleBackground || props.theme.background};
    `}

  ${props =>
    props.theme.borderBottom &&
    css`
      border-bottom: ${props => props.theme.borderBottom};
    `}
  }     

  ${Media.lg`
    font-size: ${props => `${props.theme.fontSize.lg}rem`};
  `}

  ${Media.md`
    margin: ${props => props.theme.margin.md};
    padding: ${props => props.theme.padding.md};
    border-radius: ${props => props.theme.borderRadius.md};
    font-size: ${props => `${props.theme.fontSize.md}rem`};
  `}

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}
`;

export const Spacer = styled.div`
  display: block;
  width: 100%;
  height: 2px;
  background: ${props => props.theme.background};
`;
